import type { ReactElement } from "react";
import { Route, Routes } from "react-router-dom";
import PublicHomePage from "../pages/PublicHomePage.js";

interface AppAccessRoutesProps {
  isSignedIn: boolean;
  signedInRoot: ReactElement;
  signedInPrivate: ReactElement;
  signedOutPrivate: ReactElement;
}

/**
 * The app's authentication boundary, kept separate so the public root and
 * private-route behavior can be verified without a live Clerk session.
 */
export default function AppAccessRoutes({
  isSignedIn,
  signedInRoot,
  signedInPrivate,
  signedOutPrivate,
}: AppAccessRoutesProps): ReactElement {
  return (
    <Routes>
      <Route path="/" element={isSignedIn ? signedInRoot : <PublicHomePage />} />
      <Route path="/*" element={isSignedIn ? signedInPrivate : signedOutPrivate} />
    </Routes>
  );
}
